"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../../styles");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _components = require("../../components");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));
var _useScrollTrigger = _interopRequireDefault(require("@mui/material/useScrollTrigger"));
var _Fab = _interopRequireDefault(require("@mui/material/Fab"));
var _KeyboardArrowUp = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowUp"));
var _Zoom = _interopRequireDefault(require("@mui/material/Zoom"));
var _NoSsr = _interopRequireDefault(require("@mui/material/NoSsr"));
var _ = require("./..");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Fluid = function Fluid(_ref) {
  var children = _ref.children,
    _ref$colorInvert = _ref.colorInvert,
    colorInvert = _ref$colorInvert === void 0 ? false : _ref$colorInvert,
    _ref$bgcolor = _ref.bgcolor,
    bgcolor = _ref$bgcolor === void 0 ? 'alternate.main' : _ref$bgcolor,
    pages = _ref.pages;
  var theme = (0, _styles.useTheme)();
  var isMd = (0, _useMediaQuery.default)(theme.breakpoints.up('md'), {
    defaultMatches: true
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openSidebar = _useState2[0],
    setOpenSidebar = _useState2[1];
  var handleSidebarOpen = function handleSidebarOpen() {
    setOpenSidebar(true);
  };
  var handleSidebarClose = function handleSidebarClose() {
    setOpenSidebar(false);
  };
  var open = isMd ? false : openSidebar;
  var trigger = (0, _useScrollTrigger.default)({
    disableHysteresis: true,
    threshold: 100
  });
  var scrollTo = function scrollTo(id) {
    setTimeout(function () {
      var element = document.querySelector("#".concat(id));
      if (!element) {
        return;
      }
      window.scrollTo({
        left: 0,
        top: element.offsetTop,
        behavior: 'smooth'
      });
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    id: "js--fluid-top"
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: 'relative',
    sx: {
      top: 0,
      backgroundColor: bgcolor
    },
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_.Container, {
    maxWidth: 1500,
    paddingTop: '8px !important',
    paddingBottom: '0 !important'
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    marginRight: 2
  }, /*#__PURE__*/_react.default.createElement(_components.Link, {
    underline: "none",
    component: "a",
    href: "/blocks",
    color: colorInvert ? 'common.white' : 'text.primary',
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, "Components", /*#__PURE__*/_react.default.createElement(_Box.default, {
    padding: 0.5,
    display: 'inline-flex',
    borderRadius: 1,
    bgcolor: 'primary.main',
    marginLeft: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: 'caption',
    sx: {
      color: 'common.white',
      lineHeight: 1
    }
  }, "new")))), /*#__PURE__*/_react.default.createElement(_Box.default, {
    marginRight: 2
  }, /*#__PURE__*/_react.default.createElement(_components.Link, {
    underline: "none",
    component: "a",
    href: "/docs/introduction",
    color: colorInvert ? 'common.white' : 'text.primary'
  }, "Docs")), /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(_components.ThemeModeToggler, null)))), /*#__PURE__*/_react.default.createElement(_.Container, {
    paddingY: 1,
    maxWidth: 1500
  }, /*#__PURE__*/_react.default.createElement(_components.Topbar, {
    onSidebarOpen: handleSidebarOpen,
    pages: pages,
    colorInvert: trigger ? false : colorInvert
  }))), /*#__PURE__*/_react.default.createElement(_components.Sidebar, {
    onClose: handleSidebarClose,
    open: open,
    variant: "temporary",
    pages: pages
  }), /*#__PURE__*/_react.default.createElement("main", null, children, /*#__PURE__*/_react.default.createElement(_Divider.default, null)), /*#__PURE__*/_react.default.createElement(_.Container, {
    paddingY: 4
  }, /*#__PURE__*/_react.default.createElement(_components.Footer, null)), /*#__PURE__*/_react.default.createElement(_NoSsr.default, null, /*#__PURE__*/_react.default.createElement(_Zoom.default, {
    in: trigger
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    onClick: function onClick() {
      return scrollTo('js--fluid-top');
    },
    role: "presentation",
    sx: {
      position: 'fixed',
      bottom: 24,
      right: 32
    }
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    color: "primary",
    size: "small",
    "aria-label": "scroll back to top"
  }, /*#__PURE__*/_react.default.createElement(_KeyboardArrowUp.default, null))))));
};
Fluid.propTypes = {
  children: _propTypes.default.node,
  colorInvert: _propTypes.default.bool,
  bgcolor: _propTypes.default.string
};
var _default = Fluid;
exports.default = _default;